import * as React from 'react';
import { CustomDialog, CustomInputText } from '../../custom-forms';
import { useTranslate } from '../../hooks/useTranslate';

export interface ExtendDeliveryDialogProps {
  open: boolean;
  extensionDays: number | null;
  maxDays: number;
  onChange: (value: number | null) => void;
  onClose: () => void;
  onSubmit: () => void;
  isLoading: boolean;
}

const ExtendDeliveryDialog: React.FC<ExtendDeliveryDialogProps> = ({
  open,
  extensionDays,
  maxDays,
  onChange,
  onClose,
  onSubmit,
  isLoading
}) => {
  const t = useTranslate();

  return (
    <CustomDialog
      open={open}
      onClose={onClose}
      onSubmit={onSubmit}
      maxWidth="xs"
      title={t('ORDER_PART_EXTEND_DELIVERY_LABEL', 'Prelungire livrare')}
      cancelLabel={t('VEHICLE_SEARCH_FORM_VEHICLE_NO', 'Nu')}
      confirmLabel={t('SAVE', 'Salveaza')}
      isLoading={isLoading}
    >
      <CustomInputText
        fullWidth
        id="extensionDays"
        name="extensionDays"
        type="number"
        label={t('ORDER_PART_EXTENSION_DAYS_LABEL', 'Zile prelungire')}
        value={extensionDays}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          onChange(e.target.value === '' ? null : parseInt(e.target.value))
        }
        inputProps={{ min: 1, max: maxDays }}
        validators={['required', 'minNumber:1', `maxNumber:${maxDays}`]}
        errorMessages={[
          t('VALIDATORS_REQUIRED', 'Campul este obligatoriu'),
          t('VALIDATORS_MIN_1', 'Valoarea minima este 1'),
          t('VALIDATORS_MAX_EXTENSION_DAYS', 'Numarul maxim de zile de prelungire este 30')
        ]}
      />
    </CustomDialog>
  );
};

export default ExtendDeliveryDialog;
